import React from 'react';
import Switch from 'react-switch';

import './switch.scss';

const Switcher = props => {
  return (
    <Switch
      className={props.className}
      onChange={props.onChange}
      checked={props.checked}
      disabled={props.disabled}
      uncheckedIcon={false}
      checkedIcon={false}
      height={props.height}
      width={props.width}
      onColor="#85b7d9"
      handleDiameter={props.handleDiameter}
    />
  );
};

Switcher.defaultProps = {
  height: 22,
  width: 44,
  handleDiameter: 18,
};

export default Switcher;
